/**
 * Textarea — 멀티라인 텍스트 입력 필드
 *
 * Input과 동일한 label / error / helperText 패턴을 사용하며 forwardRef를 지원한다.
 */

import { forwardRef, TextareaHTMLAttributes } from 'react'
import { cn } from '../../lib/cn.js'
import styles from './Textarea.module.css'

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** 입력 크기. 기본값 md */
  size?: 'sm' | 'md' | 'lg'
  /** 필드 레이블 텍스트 */
  label?: string
  /** 에러 메시지 */
  error?: string
  /** 보조 안내 텍스트 */
  helperText?: string
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { size = 'md', label, error, helperText, className, id, ...props },
  ref,
) {
  const textareaId =
    id ?? (label ? `textarea-${Math.random().toString(36).slice(2, 9)}` : undefined)

  return (
    <div className={cn(styles.wrapper, className)}>
      {label && (
        <label className={styles.label} htmlFor={textareaId}>
          {label}
        </label>
      )}
      <textarea
        {...props}
        ref={ref}
        id={textareaId}
        className={cn(styles.textarea, styles[size], error && styles.textareaError)}
      />
      {error && <span className={styles.errorText}>{error}</span>}
      {!error && helperText && <span className={styles.helperText}>{helperText}</span>}
    </div>
  )
})
